import PreLoader from 'components/Others/PreLoader';
import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { sess_get, sess_post } from 'utils/HttpRequests';
import { useHistory } from 'react-router';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { faChalkboardTeacher } from '@fortawesome/free-solid-svg-icons';
import Input from './Input';

export function Abc(props) {
  const [min, setMin] = useState(0);
  const [max, setMax] = useState(0);
  const [reward, setReward] = useState('');
  const [type, setType] = useState('');
  const [tableData, setTableData] = useState([]);

  const addRow = (e) => {
    e.preventDefault();
    if (!min || min === 0) return;
    if (!max || max === 0) return;
    if (reward === '---' || type === '---') return;

    const data = {
      reward_type: reward,
    };
    if (reward === 'CASH') {
      data.payout_type = type;
      data.amount = {
        min: parseFloat(min),
        max: parseFloat(max),
      };
    }
    if (reward === 'VALIDITY') {
      data.validity = {
        min,
        max,
      };
    }
    data.id = Math.random().toString();
    const a = tableData;

    const c = tableData;
    c.push(data);
    setTableData(c);
    props.setGraphData(c);
    setMin(0);
    setMax(0);
  };

  const deleteGraphPayoutRow = (i) => {
    console.log(i, tableData);
    const a = tableData;
    a.splice(i, 1);
    setTableData(a);
    props.setGraphData(a);
  };

  return (
    <div>
      <div style={{ display: 'flex', alignContent: 'center', alignItems: 'center' }}>
        <h3 style={{ marginRight: '40px' }}>Reward Graph</h3>
        <select value={reward} onChange={(e) => setReward(e.target.value)}>
          {
            props?.payoutOptions?.length > 0 && props.payoutOptions.map((item) => (
              <option value={item}>{item}</option>
            ))
          }
        </select>
      </div>
      <div style={{ padding: '5px', display: 'flex', justifyContent: 'space-around' }}>
        {reward === 'CASH'
          && (
            <select value={type} onChange={(e) => setType(e.target.value)}>
              {
                props?.payoutType?.length > 0 && props.payoutType.map((item) => (
                  <option value={item}>{item}</option>
                ))
              }
            </select>
          )}
        <div>
          <label>Min</label>
          <input value={min} min={0} type="number" step="0.01" onChange={(e) => setMin(e.target.value.replace(/^0+/, ''))} />
        </div>
        <div>
          <label>Max</label>
          <input value={max} min={min || 0} type="number" step="0.01" onChange={(e) => setMax(e.target.value.replace(/^0+/, ''))} />
        </div>
      </div>
      <button onClick={(e) => { addRow(e); }} className="btn btn-primary">Add</button>

      <table>
        <thead>
          <th>Event Count</th>
          <th>Reward Type</th>
          <th>Unit</th>
          <th>Min</th>
          <th>Max</th>
          {/* <th>Remove</th> */}
        </thead>
        <tbody>
          {
            tableData.length > 0
              ? tableData?.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item?.reward_type}</td>
                  <td>{item?.payout_type}</td>
                  <td>{item?.amount?.min || item?.validity?.min}</td>
                  <td>{item?.amount?.max || item?.validity?.max}</td>
                  {/* <td><button type="button" onClick={() => {
                    deleteGraphPayoutRow(index);
                  }}>Remove</button></td> */}
                </tr>
              ))
              : null
          }
        </tbody>
      </table>
    </div>
  );
}

export default function CreateRewards() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [notificationList, setNotificationList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [methodsList, setMethodsList] = useState([]);
  const [rewardsTypes, setRewardsTypes] = useState(['---', 'CASH', 'VALIDITY', 'NONE']);
  const [payoutTypes, setPayoutTypes] = useState(['---', 'percent', 'absolute']);

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [budget, setBudget] = useState(0);
  const [status, setStatus] = useState('');
  const [priority, setPriority] = useState(0);
  const [blockedPriorities, setBlockedPriorities] = useState([]);
  const [priorityError, setPriorityError] = useState('');
  const [userType, setUserType] = useState('');
  const [paymentType, setPaymentType] = useState('');
  const [event, setEvent] = useState('');
  const [notification, setNotification] = useState('');
  const [floorPayoutType, setFloorPayoutType] = useState('---');
  const [floorPayoutMin, setFloorPayoutMin] = useState(0);
  const [floorPayoutMax, setFloorPayoutMax] = useState(0);
  const [floorPayoutCashType, setFloorPayoutCashType] = useState('---');
  const [graphPayoutTable, setGraphPayoutTable] = useState([]);
  const [trustedServicesList, setTrustedServicesList] = useState([]);
  const [trustedServices, setTrustedServices] = useState([]);
  const history = useHistory();

  const createNew = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = {};

    formData.name = name;
    formData.description = description;
    formData.start_date = startDate;
    formData.end_date = endDate;
    formData.budget = parseInt(budget);
    formData.status = status;
    formData.method = event;
    formData.priority = parseInt(priority);
    formData.user_type = userType;
    formData.is_subscription = (paymentType === 'RECURRING');
    formData.trusted_services = [];
    formData.pn_template = notification;
    if (trustedServices.length > 0) {
      const list = [];
      trustedServices.forEach((item) => { if (item.value !== 'All') { list.push(item.id); } });
      formData.trusted_services = list;
    }
    if (graphPayoutTable.length > 0) {
      const payoutTable = graphPayoutTable;
      payoutTable.forEach((item, index) => { item.level = index + 1; });
      formData.payout_graph = payoutTable;
    }

    const floorPayoutData = {
      reward_type: floorPayoutType,
      payout_type: floorPayoutCashType,
      min: parseFloat(floorPayoutMin),
      max: parseFloat(floorPayoutMax),
    };

    formData.floor_payout = floorPayoutData;

    sess_post('admin/console/flight', localStorage.getItem('admin-panel-sessionToken'), formData)
      .then((resp) => {
        setLoading(false);
        toast.success('created successfully');
        history.push('/rewards');
      })
      .catch((err) => {
        toast.error(err?.response?.data?.error?.reason);
        setError(err?.response?.data?.error?.reason);
        setLoading(false);
      });
  };

  useEffect(() => {
    sess_get('admin/console/template/push', localStorage.getItem('admin-panel-sessionToken'))
      .then((res) => { setNotificationList(res?.data?.response); })
      .catch((err) => { console.log('err'); });

    sess_get('admin/console/flight-statuses-list', localStorage.getItem('admin-panel-sessionToken'))
      .then((res) => {
        setStatusList(res?.data?.response?.availableStatuses);
        setStatus(res?.data?.response?.availableStatuses?.[0]);
      })
      .catch((err) => {
        console.log('err', err);
      });

    sess_get('admin/console/flight-methods-list', localStorage.getItem('admin-panel-sessionToken'))
      .then((res) => {
        setMethodsList(res?.data?.response?.availableMethods);
        setEvent(res?.data?.response?.availableMethods?.[0]);
      })
      .catch((err) => {
        console.log('err', err);
      });

    sess_get('admin/console/trusted-services', localStorage.getItem('admin-panel-sessionToken'))
      .then((res) => {
        let data = res?.data?.response?.services;
        data = data.map((item) => ({
          ...item,
          label: item.id,
          value: item.id,
        }));
        // data.unshift({ label: 'All', value: 'All' });
        setTrustedServicesList(data);
      })
      .catch((err) => { console.log('err'); });

    sess_get('admin/console/flight-priorities-list', localStorage.getItem('admin-panel-sessionToken'))
      .then((res) => {
        setBlockedPriorities(res?.data?.response?.priorities_in_use);
      })
      .catch((err) => { console.log('err'); });
  }, []);

  useEffect(() => {
    if (paymentType === 'RECURRING') {
      setRewardsTypes(['---', 'CASH', 'NONE']);
    } else {
      setRewardsTypes(['---', 'CASH', 'VALIDITY', 'NONE']);
    }
  }, [paymentType]);

  useEffect(() => {
    if (event === 'calls-ts') {
      setPayoutTypes(['---', 'absolute']);
    } else {
      setPayoutTypes(['---', 'percent', 'absolute']);
    }
  }, [event]);

  const onSelect = (selectedList, selectedItem) => {
    console.log(selectedItem, selectedList);
    return;
    const { id } = selectedItem;
    const list = trustedServices;
    list.push(id);
    setTrustedServices(list);
  };

  const onRemove = (selectedList, removedItem) => {
    const { id } = removedItem;
    const list = trustedServices;

    const index = list.indexOf(id);

    list.splice(index, 1);

    setTrustedServices(list);
  };

  const onMultiselectChange = (value, event) => {
    console.log(value, event);
    if (event.action === 'select-option' && event.option.value
      === 'All') {
      setTrustedServices([{ value: 'All', option: 'All' }, ...trustedServicesList]);
    } else if (event.action === 'deselect-option'
      && event.option.value === 'All') {
      setTrustedServices([]);
    } else if (event.action === 'deselect-option') {
      setTrustedServices(value.filter((o) => o.value !== 'All'));
    } else if (value.length === trustedServicesList.length - 1) {
      setTrustedServices(trustedServicesList);
    } else {
      setTrustedServices(value);
    }
  };

  const priorityCheckAndUpdate = (val) => {
    val = val.replace(/^0+/, '');
    val = parseInt(val);
    setPriority(val);
    if (blockedPriorities.includes(val)) {
      setPriorityError('Priority already exists');
    } else {
      setPriorityError('');
    }
  };

  const a = graphPayoutTable;
  return (
    <div style={{ width: '60%', margin: '40px auto' }}>
      <h1>Create New</h1>
      <ToastContainer />
      {loading
        && <PreLoader />}
      <form onSubmit={createNew} style={{ padding: '40px 0', borderRadius: '8px' }}>
        <div style={{
          border: '1px solid black',
          padding: '20px',
          borderRadius: '8px',
          marginBottom: '20px',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          columnGap: '10px',
          rowGap: '15px',
        }}
        >
          <Input label="Name" type="text" value={name} setValue={(val) => setName(val)} />
          <Input label="Description" type="text" value={description} setValue={(val) => setDescription(val)} />
          <Input label="Start date" type="date" value={startDate} setValue={(val) => setStartDate(val)} min={new Date().toISOString().split('T')[0]} />
          <Input label="End date" type="date" value={endDate} setValue={(val) => setEndDate(val)} min={startDate || new Date().toISOString().split('T')[0]} />
          <Input label="Budget" type="number" value={budget} setValue={(val) => setBudget(val)} />
          <Input label="Status" type="select" options={statusList} value={status} setValue={(val) => setStatus(val)} />
          <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
            <label style={{ margin: '0' }}>Priority</label>
            <input label="Priority" type="number" value={priority} min={0} onChange={(e) => { priorityCheckAndUpdate(e.target.value); }} />
            <p style={{ color: 'red' }}>{priorityError}</p>
          </div>
          <Input label="User Type" type="select" options={['---', 'PRO', 'ESSENTIAL', 'ALL']} value={userType} setValue={(val) => setUserType(val)} />
          <Input label="Payment Type" type="select" options={['---', 'NON-RECURRING', 'RECURRING']} value={paymentType} setValue={(val) => setPaymentType(val)} />
          <Input label="Event" type="select" options={methodsList} value={event} setValue={(val) => setEvent(val)} />
          <Input label="Notification" type="notification" options={notificationList} value={notification} setValue={(val) => setNotification(val)} />
          {
            event === 'calls-ts'
            && (
              <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
                <label style={{ margin: 0 }}>Trusted Services</label>
                <ReactMultiSelectCheckboxes
                  options={[{ label: 'All', value: 'All' }, ...trustedServicesList]}
                  value={trustedServices}
                  onChange={onMultiselectChange}
                  setState={setTrustedServices}
                />
              </div>
            )
          }

        </div>
        <div style={{
          border: '1px solid black', padding: '20px', borderRadius: '8px', marginBottom: '20px',
        }}
        >
          <div style={{ display: 'flex', alignContent: 'center', alignItems: 'center' }}>

            <h3 style={{ marginRight: '40px' }}>Floor Payout</h3>
            <Input type="select" options={rewardsTypes} value={floorPayoutType} setValue={(val) => setFloorPayoutType(val)} />
          </div>
          <div style={{ padding: '5px', display: 'flex', justifyContent: 'space-around' }}>

            {floorPayoutType === 'NONE' ? null
              : (
                <div style={{
                  padding: '5px', display: 'flex', justifyContent: 'space-around', gap: '30px',
                }}
                >
                  {
                    floorPayoutType === 'CASH'
                      ? <Input label="Payout Type" type="select" options={payoutTypes} value={floorPayoutCashType} setValue={(val) => setFloorPayoutCashType(val)} />
                      : null
                  }

                  <Input label="Min" type="number" val={floorPayoutMin} min={0} setValue={(val) => setFloorPayoutMin(val)} />
                  <Input label="Max" type="number" val={floorPayoutMax} min={floorPayoutMin} setValue={(val) => setFloorPayoutMax(val)} />
                </div>
              )}
          </div>

        </div>
        {event?.toLowerCase() !== 'referee'
          && (
            <div style={{ border: '1px solid black', padding: '20px', marginBottom: '20px' }}>

              <Abc payoutOptions={rewardsTypes} payoutType={payoutTypes} setGraphData={((data) => setGraphPayoutTable(data))} />
            </div>
          )}
        <div style={{ textAlign: 'center' }}>

          <p style={{ marginBottom: '10px', color: 'red' }}>{error}</p>
          <button type="submit" className="btn btn-primary">Create</button>
        </div>
      </form>
    </div>
  );
}
